import { CadeiaPapel } from '../../types/leito';

export interface CadeiaWizardSelection {
  empresaId: string;
  papel: CadeiaPapel;
}

const order = ['origem', 'transporte', 'destino'] as const;

export function buildCadeiaPayload(
  selection: Record<string, CadeiaWizardSelection | null>
): Array<CadeiaWizardSelection & { ordem: number }> {
  return order.flatMap((key, index) => {
    const item = selection[key];
    return item ? [{ ...item, ordem: index + 1 }] : [];
  });
}

export function canRequestActivation(
  saved: boolean,
  hasPermission: boolean,
  knownBalance: number | null
): boolean {
  return saved && hasPermission && knownBalance !== 0;
}
